import { styled } from 'stitches.config'
import { Text } from 'components/Text'
export const CustomMealPlanRoot = styled('div', {
  position: 'relative',
  width: '100%',
  height: '100%',
  overflow: 'hidden',

  '@bp3': {
    height: '100%',
  },
})

export const BackgroundImage = styled('div', {
  position: 'relative',
  zIndex: 0,
  width: '100%',
  height: '100%',
  maxWidth: '1920px',
  margin: 'auto',
})

export const DesktopImage = styled('div', {
  display: 'none',
  position: 'relative',
  width: '100%',
  height: '100%',
  maxWidth: '1920px',
  margin: '0 auto',

  '@bp3': {
    display: 'block',
    lineHeight: 0,
  },
})

export const MobileImage = styled('div', {
  display: 'block',
  position: 'relative',
  width: '100%',
  height: '100%',
  maxWidth: '374px',
  margin: '0 auto',
  lineHeight: 0,

  '@bp3': {
    display: 'none',
  },
})

export const ContentWrapper = styled('div', {
  position: 'absolute',
  right: 0,
  top: 0,
  zIndex: 2,
  display: 'none',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  padding: '$4',
  height: '100%',
  maxWidth: '380px',
  margin: '0 auto',
  '@bp3': {
    marginRight: '1.5%',
    maxWidth: '720px',
    display: 'flex'
  },

  '@bp4': {
    marginRight: '5%',
  },
})

export const Title = styled('h2', {
  align: 'center',
  fontSize: '$h2',
  fontWeight: '$medium',
  textAlign: 'center',
  color: '$accent-white',
  marginBottom: '$2',
  position: 'absolute',
  bottom: '40px',
  left: 0,
  right: 0,
  margin: 'auto',
  width: '300px',
  zIndex: 1,
  lineHeight: 1.14
})

export const DescriptionWrapper = styled('div', {
  width: '100%',
  maxWidth: '370px',
  margin: 'auto',
  background: '$quaternary-535',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  gap: '$3',
  padding: '$4 $2',
  '@bp3': {
    display: 'none',
  }
})